import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { driverVersions } from 'app/registries/consts/tabular-consts';
import { LinkedServiceUtils } from './linked-service.utils';

export const quickBooksReservedKeys = ['endpoint', 'companyId', 'consumerKey', 'consumerSecret', 'refreshToken', 'useEncryptedEndpoints', 'encryptedCredential'];

@Metamodel.model({
    name: 'QuickBooks',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.QuickBooks_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.QuickBooks_DisplayText)
    ]
})
export class QuickBooksLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.VersionLabel
    })
    public version?: driverVersions = driverVersions.v2;

    @Metamodel.attribute({
        display: stringResources.ModelName_Endpoint
    })
    public endpoint?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_CompanyId
    })
    public companyId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientId
    })
    public consumerKey?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientSecret,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public consumerSecret?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_AccessToken,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public accessToken?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_AccessTokenSecret,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public accessTokenSecret?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_RefreshToken,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public refreshToken?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseEncryptedEndpoints
    })
    public useEncryptedEndpoints?: boolean;

    public isOldResource?: boolean; // upgrade from OAuth 1.0 to 2.0

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public convertV1toV2(context: { inlineDataset?: boolean }): QuickBooksLinkedService {
        const copy = LinkedServiceUtils.commonV1ToV2(context, this) as QuickBooksLinkedService;
        const secrets: Array<keyof QuickBooksLinkedService> = ['refreshToken', 'consumerSecret'];
        secrets.forEach((key) => {
            if (!(copy[key] instanceof AzureKeyVault)) {
                delete copy[key];
            }
        });
        return copy;
    }
}
